import { Box } from "@mui/material";
import { useContext, useRef, useState } from "react";
import { ParagraphText } from "../../../../Libraries";
import moment from "moment";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import allTransactionStyles from "./AllTransaction.module.css";
import UBRightSidebar from "../../../common/UBRightSidebar";
import TransactionDetail, {
  SUPPORTED_TRANSACTION_TYPES,
} from "../../../common/TransactionDetail";
import {
  getWalletTransactionDescription,
} from "./walletDashboardTransactionUtils";
import DownloadReceipt from "../../../common/DownloadReceipt";
import { LanguageContext } from "../../../../context/LanguageContext";
import { downloadReceiptImage } from "../../../../utils";

const TransactionItemList = ({ item }) => {
  const [I18n] = useContext(LanguageContext);
  const { created_at, amount, mode, type } = item || {};
  const [openDetailSidebar, setOpenDetailSidebar] = useState(false);
  const isDetailSupported = SUPPORTED_TRANSACTION_TYPES.includes(type);
  const receiptRef = useRef();
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  const handleOpen = () => {
    if (!isDetailSupported) return;
    if (!openDetailSidebar) {
      setOpenDetailSidebar(true);
      triggerLogEvent(analytics, "w_transactions_detail");
    }
  };
  const tid = item?.id || "";
  const formattedDate = created_at ? moment(created_at).format("D MMMM YYYY, hh:mm A") : "";

  const receiptRecipient = item?.customer_name ? item?.customer_name : "";
  const receiptRows = [
    { label: I18n.by || "By", value: receiptRecipient || "-" },
    { label: I18n.tid, value: tid },
    { label: I18n.date || "Date", value: formattedDate },
    { label: I18n.fee || "Fee", value: item?.fee ? `Rs. ${item.fee}` : `Rs. 0 ${I18n.fee_free}` },
    { label: I18n.total_amount || "Total amount", value: `Rs. ${Math.abs(amount) || 0}` },
  ];

  const handleDownload = () =>
    downloadReceiptImage(receiptRef, {
      setIsDownloadLoading, analyticsEvent: "transaction_download",
      fileName: "Rupin Transaction Receipt",
    });

  return (
    <Box
      id={`all_transactions_row_${tid}`}
      className="invoiceListTableBody accountTableHeaderMain"
      onClick={handleOpen}
    >
      <DownloadReceipt
        ref={receiptRef}
        amount={Math.abs(amount)}
        headerText={I18n.bill_paid_with_rupin}
        recipientName={receiptRecipient}
        bankInfo=""
        rows={receiptRows}
      />
      {/* Date */}
      <Box className="invListTableHeaderCol fourColumn textLeft sidebarOption">
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {moment(created_at).format("DD MMM YYYY")}
        </ParagraphText>
      </Box>

      {/* Account */}
      <Box className="invListTableHeaderCol fourColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor displayFlex">
          {getWalletTransactionDescription(item).title}
        </ParagraphText>
      </Box>

      {/* Description */}
      <Box className="invListTableHeaderCol fourColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newLightColor displayFlex alignCenter">
          {getWalletTransactionDescription(item).subtitle}
        </ParagraphText>
      </Box>

      {/* Amount */}
      <Box
        className={`invListTableHeaderCol fourColumn textReight amountColumnNewWrapper ${allTransactionStyles.amountCol}`}
      >
        <ParagraphText
          className={"fontSize14 fontWeight400 transAmount textRight newFontColor"}
        >
          {mode === "credit" ? (
            <span
              className={allTransactionStyles.transAmountIcon}
            >
              +
            </span>
          ) : (
            <span
              className={allTransactionStyles.transAmountIcon}
            >
              -
            </span>
          )}
          <span className={allTransactionStyles.transAmountValue}>
            {`Rs. ${formatNum(Math.abs(amount))}`}
          </span>
        </ParagraphText>
      </Box>
      {openDetailSidebar ? (
        <UBRightSidebar
          id="wallet_transaction_detail_sidebar"
          title={I18n.transaction_detail}
          open={openDetailSidebar}
          onClose={() => setOpenDetailSidebar(false)}
        >
          <TransactionDetail transaction={item} onDownloadReceipt={handleDownload} isDownloadLoading={isDownloadLoading} />
        </UBRightSidebar>
      ) : null}
    </Box>
  );
};

export default TransactionItemList;
